// Set a Cookie
export const setCookie = (cName, cValue, expDays) => {
  let date = new Date();
  date.setTime(date.getTime() + expDays * 24 * 60 * 60 * 1000);
  const expires = "expires=" + date.toUTCString();
  const secure = ";secure";
  // const domain = ";domain=textgenuss.herokuapp.com";
  document.cookie = ` ${cName} =  ${cValue} ; ${expires} ; path=/ ${secure} ; SameSite=none ;`;
};

// Get a Cookie
export const getCookie = (cname) => {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

// Deleted a Cookie
export const deleteAllCookies = () => {
  let cookies = document.cookie.split(";");
  console.log(cookies);
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i];
    console.log(cookie);
    let eqPos = cookie.indexOf("=");
    let name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = name + `=;expires=Thu, 18 Dec 2020 12:00:00 UTC`;
  }
};
